import React from "react";
//#region redux
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { HTMLConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
import { CreateCustomerFooterProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { Portal } from "@mui/material";
import { WizardFormFooter } from "components/common";
//#endregion

const CreateCustomerFooter: React.FC<CreateCustomerFooterProps> = ({ form, onSubmitSuccess, wizard, submitForm }) => {
  const isFormLoading = form.values.alreadyExists === undefined;

  const footerMount = document.getElementById(
    `customerCreationLayout${HTMLConstants.EntityCreationLayoutFooterPortalId}`
  );

  return (
    <Portal container={footerMount}>
      <WizardFormFooter
        actions={[
          {
            text: TranslationKeys.Invoice.SaveClient,
            type: StyleEnums.DisplayType.Success,
            successMessage: TranslationKeys.Invoice.CustomerCreatedMessage,
            onClick: submitForm,
            onActionSuccess: onSubmitSuccess,
            isDisabled: isFormLoading,
          },
        ]}
        wizardProps={wizard}
      />
    </Portal>
  );
};

export default CreateCustomerFooter;
